/**
 * Composable factory for the bulk import service slice.
 * Stateless: all methods delegate to the request functions and take `entity`
 * as their first argument. Stores call this; views never call services directly.
 */

import {
  createImportRequest,
  validateImportRequest,
  previewImportRequest,
  confirmImportRequest,
  fetchImportStatusRequest,
  fetchImportErrorsRequest,
  fetchCombinedImportsRequest,
  downloadImportTemplateFile,
  downloadImportReportFile,
  exportPrefilledRequest,
  exportPrefilledBlobRequest,
  fetchBulkExportsRequest,
  downloadBulkExportFile,
} from './bulkImportApi'

export function useBulkImportApi() {
  return {
    createImport: createImportRequest,
    validateImport: validateImportRequest,
    previewImport: previewImportRequest,
    confirmImport: confirmImportRequest,
    fetchImportStatus: fetchImportStatusRequest,
    fetchImportErrors: fetchImportErrorsRequest,
    fetchCombinedImports: fetchCombinedImportsRequest,
    downloadImportTemplate: downloadImportTemplateFile,
    downloadImportReport: downloadImportReportFile,
    exportPrefilled: exportPrefilledRequest,
    exportPrefilledBlob: exportPrefilledBlobRequest,
    fetchBulkExports: fetchBulkExportsRequest,
    downloadBulkExport: downloadBulkExportFile,
  }
}
